<span [class]="{ active: isActive }">
  <a
    routerLinkActive="selectedmenu"
    class="menuitems"
    [class]="{ hastext: hasDisplayText() }"
    [routerLink]="link"
    [routerLinkActiveOptions]="{ exact: true }"
  >
    <ion-icon
      class="sidebar-icon"
      [class]="{ active: isActive }"
      [src]="icon()"
    />
    @if (hasDisplayText()) {
      <span class="main-label" [class]="{ active: isActive }">
        {{ displayText() }}
      </span>
    }
  </a>
</span>
